<template>
  <v-container>
    <p class="text-center text-h4">
      {{ spaceInfo.ParkingReservedSpace_Name }} - 剩餘車位數
    </p>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-card>
          <v-simple-table>
            <template>
              <thead>
                <tr>
                  <th>日期</th>
                  <!-- <th>剩餘預約數</th> -->
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in spaceLeft"
                  :key="item.ID"
                >
                  <td>{{ item.Model_Date | toDateFormat("YYYY-MM-DD") }} ({{ weekday(item.Model_Date) }})</td>
                  <!-- <td>
                    {{ item.Model_Left }}
                  </td> -->
                  <td>
                    <v-btn
                      v-if="item.Model_Left > 0"
                      color="primary"
                      @click="goPayment(item.Model_Date)"
                    >
                      預約
                    </v-btn>
                    <span
                      v-else
                      style="color:red"
                    >已滿</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      persistent
      width="600px"
    >
      <v-card>
        <v-card-title class="text-h5 font-weight-bold grey lighten-2">
          預約確認
          <v-spacer />
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form
            class="mt-5"
            ref="checkoutForm"
            v-model="validCheckout"
          >
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model.number="checkoutModel.Model_ReservedDay"
                  :rules="reservedDayRules"
                  label="停放天數"
                  maxlength="2"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="checkoutModel.Model_Contact"
                  :rules="[(v) => !!v || '必填項目']"
                  label="姓名"
                  maxlength="20"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="checkoutModel.Model_CarShow"
                  :rules="[(v) => !!v || '必填項目', (v) => /^((軍[A-Z]-[0-9]{5})|([A-Z0-9]{1,4}-[A-Z0-9]{1,4}))$/.test(v) || '車號規格錯誤']"
                  label="車牌號碼 (例: AA-1234)"
                  maxlength="10"
                  @input="(val) => (checkoutModel.Model_CarShow = val.toUpperCase())"
                ></v-text-field>
              </v-col>
              <!--
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="checkoutModel.Model_Phone"
                  :rules="[(v) => !!v || '必填項目', (v) => /^(09[0-9]{8})$/.test(v) || '手機格式錯誤']"
                  label="手機號碼"
                  maxlength="10"
                ></v-text-field>
              </v-col>
              -->
            </v-row>
            <v-row v-if="false">
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="checkoutModel.invType"
                  :items="invOptions"
                  label="發票類型"
                ></v-select>
              </v-col>
              <v-col
                v-if="checkoutModel.invType === '統編'"
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="checkoutModel.Model_BuyerNum"
                  :rules="[(v) => !!v || '必填項目', (v) => checkUniformNo(v) || '統一編號格式錯誤']"
                  label="統一編號"
                  maxlength="8"
                ></v-text-field>
              </v-col>
              <v-col
                v-if="checkoutModel.invType === '手機載具'"
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="checkoutModel.Model_VehicleCode"
                  :rules="[(v) => !!v || '必填項目', (v) => /^\/[\dA-Z0-9+-.]{7}$/.test(v) || '請輸入正確手機載具格式']"
                  label="手機載具"
                  maxlength="8"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-none d-sm-flex">
              <v-col md="6">
                <span class="text-h6">使用區間</span><br class="d-none d-sm-flex" />
                <span class="text-subtitle-1">{{ checkoutModel.Model_StartDate | toDateFormat('yyyy/MM/DD') }} - {{ endDate | toDateFormat('yyyy/MM/DD') }}</span>
              </v-col>
              <v-col md="6">
                <span class="text-h6">訂單總金額</span><br class="d-none d-sm-flex" />
                <span class="text-subtitle-1">NT$ {{ payment }}</span>
              </v-col>
            </v-row>
            <v-row class="d-flex d-sm-none">
              <v-col cols="6">
                <span class="text-h6">使用區間</span><br class="d-none d-sm-flex" />
              </v-col>
              <v-col
                cols="6"
                align="end"
              >
                <span class="text-subtitle-1">{{ checkoutModel.Model_StartDate | toDateFormat('yyyy/MM/DD') }} - {{ endDate | toDateFormat('yyyy/MM/DD') }}</span>
              </v-col>
            </v-row>
            <v-row class="d-flex d-sm-none">
              <v-col cols="6">
                <span class="text-h6">訂單總金額</span><br class="d-none d-sm-flex" />
              </v-col>
              <v-col
                cols="6"
                align="end"
              >
                <span class="text-subtitle-1">NT$ {{ payment }}</span>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-text style="margin-top: 20px;">
          <v-row>
            <vue-recaptcha
              @verify="captchaVerified"
              @expired="captchaExpired"
              ref="recaptcha"
              sitekey="6LcQxDsmAAAAAF_eMRmUUpuJ7U0I5kyZBFWSG2Xg"
            />
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            關閉
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="goCheckout"
          >
            送出
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="remindDialog"
      max-width="700px"
    >
      <v-card>
        <v-card-title class="text-h5 font-weight-bold grey lighten-2">
          您已完成線上預約登記
          <v-spacer />
          <v-btn
            icon
            @click="remindDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p class="text-h5 text-center mt-3 font-weight-bold">
            預約車號 : {{ showCarNo }}
          </p>
          <p
            class="text-h5 mt-1"
            style="color: black"
          >
            1.請再次確認登記車號、日期、天數是否正確
          </p>
          <p
            class="text-h5 text-black mt-1"
            style="color: black"
          >
            2.完成預約後僅供查詢及取消
          </p>
          <p
            class="text-h5 text-black mt-1"
            style="color: black"
          >
            3.如需修改請自行取消後重新預約
          </p>
          <p
            class="text-h5 text-black mt-1"
            style="color: black"
          >
            4.請依指定預約日期至指定場地停放車輛後完成報到手續，
            若未完成報到手續則以一般臨停計價。
          </p>

          <v-divider class="mt-2 mb-2" />
          <p class="text-center text-h4">
            場地位置圖
          </p>
          <v-img
            v-if="siteInfo.ParkingReserved_SiteInfoCode"
            :src="require(`@/assets/map_${siteInfo.ParkingReserved_SiteInfoCode}.jpg`)"
          ></v-img>
        </v-card-text>

        <v-card-text v-if="siteInfo.ParkingReserved_SiteInfoCode == 84416">
          <p class="text-center text-h4">
            報到繳費地點P4停車場B1
          </p>
          <v-img src="@/assets/checkin.jpg"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="remindDialog = false"
          >
            關閉
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="pauseDialog"
      transition="dialog-bottom-transition"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>系統提示</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-card-text>
          <div class="mt-5">
            <p style="font-size: 20px; color:red;">『系統預約整理中，將在零晨00:00恢復使用。』</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          right
          bottom
          color="success"
          v-bind="attrs"
          v-on="on"
          @click="$router.go(-1)"
        >
          <v-icon>mdi-keyboard-return</v-icon>
        </v-btn>
      </template>
      <span>返回</span>
    </v-tooltip>

  </v-container>
</template>

<script>
import moment from 'moment';
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  name: 'ReservedList',
  components: { VueRecaptcha },
  data: () => ({
    spaceID: 0,
    siteInfo: {},
    spaceInfo: {},
    spacePart: [],
    spaceLeft: [],
    siteCalendar: [],
    sysCalendar: [],
    dialog: false,
    remindDialog: false,
    validCheckout: false,
    checkoutModel: {
      Model_BuyerNum: null,
      Model_VehicleCode: null,
      Model_StartDate: moment().format('yyyy-MM-DD'),
      Model_EndDate: null,
      Model_Contact: null,
      Model_CarShow: null,
      Model_Phone: null,
      invType: '紙本',
      Model_ReservedDay: 1,
      Model_SpaceID: 0,
      ReCAPTCHAToken: null
    },
    invOptions: ['紙本', '統編', '手機載具'],
    reservedDayRules: [
      (v) => !!v || '必填項目',
      (v) => !/\D/.test(v) || '請輸入數字'
    ],
    captchaVerify: false,
    showCarNo: null,
    pauseDialog: false
  }),
  computed: {
    endDate() {
      if (this.checkoutModel.Model_ReservedDay > 0) {
        return moment(this.checkoutModel.Model_StartDate).add(
          this.checkoutModel.Model_ReservedDay - 1,
          'days'
        );
      } else {
        return moment(this.checkoutModel.Model_StartDate);
      }
    },
    payment() {
      const startDate = this.checkoutModel.Model_StartDate;
      let totalPrice = 0;
      let tempDete;
      for (let i = 0; i < this.checkoutModel.Model_ReservedDay; i++) {
        tempDete = moment(startDate).add(i, 'day');

        // 管理行事曆 (最高級)
        let calendar = this.siteCalendar.find((x) =>
          moment(x.ParkingReservedCalendar_Date).isSame(tempDete, 'day')
        );
        if (calendar) {
          totalPrice += this.datePrice(
            calendar.ParkingReservedCalendar_Type,
            tempDete
          );
          continue;
        }

        //  系統行事曆 (次級)
        calendar = this.sysCalendar.find((x) =>
          moment(x.Calendar_Date).isSame(tempDete, 'day')
        );
        if (calendar) {
          totalPrice += this.datePrice(calendar.Calendar_Type, tempDete);
          continue;
        }

        // 依星期判斷 (最後)
        switch (moment(tempDete).day()) {
          case 6:
          case 0:
            //  假日
            totalPrice += this.datePrice(2, tempDete);
            break;
          default:
            //  平日
            totalPrice += this.datePrice(1, tempDete);
            break;
        }
      }
      return totalPrice;
    }
  },
  watch: {
    dialog(value) {
      if (!value) {
        // 初始化
        this.$refs.checkoutForm.resetValidation();
        this.checkoutModel = {
          Model_BuyerNum: null,
          Model_VehicleCode: null,
          Model_StartDate: moment().format('yyyy-MM-DD'),
          Model_EndDate: null,
          Model_Contact: null,
          Model_CarShow: null,
          Model_Phone: null,
          invType: '紙本',
          Model_ReservedDay: this.siteInfo.ParkingReserved_MinReserveDays
            ? this.siteInfo.ParkingReserved_MinReserveDays
            : 1,
          Model_SpaceID: 0
        };
      }
    }
  },
  created() {
    if (!this.$route.params.id) {
      this.msg('查無指定區域', 2000);
      this.$router.replace('/');
    }
    this.spaceID = this.$route.params.id;
    this.search();
  },
  methods: {
    search() {
      this.dbio('/ParkingOnlyReserved/GetReservedSpaceLeft', {
        SpaceID: this.$route.params.id
      }).then((response) => {
        this.pauseDialog = response.Pause;
        if (!this.pauseDialog) {
          this.siteInfo = response.ParkingReserved;
          this.spaceInfo = response.ParkingReservedSpace;
          this.spaceLeft = response.List_ParkingReservedLeft;
          this.spacePart = response.ListParkingReservedSpacePart;
          // 初始為可預約最少天數
          this.checkoutModel.Model_ReservedDay =
            this.siteInfo.ParkingReserved_MinReserveDays;
          this.reservedDayRules.push(
            (v) =>
              (v >= this.siteInfo.ParkingReserved_MinReserveDays &&
                v <= this.siteInfo.ParkingReserved_MaxReserveDays) ||
              `超出可預約天數(${this.siteInfo.ParkingReserved_MinReserveDays} - ${this.siteInfo.ParkingReserved_MaxReserveDays})`
          );

          this.siteCalendar = response.List_ParkingReservedCalendar;
          this.sysCalendar = response.List_Calendar;
        }
      });
    },
    allowedMonths(val) {
      const date = moment(val);
      const now = moment();

      return date.diff(now, 'days') >= 0;
    },
    weekday(val) {
      let date = moment(val);
      let result = '';
      switch (date.weekday()) {
        case 0:
          result = '日';
          break;
        case 1:
          result = '一';
          break;
        case 2:
          result = '二';
          break;
        case 3:
          result = '三';
          break;
        case 4:
          result = '四';
          break;
        case 5:
          result = '五';
          break;
        case 6:
          result = '六';
          break;
      }

      return result;
    },
    goPayment(val) {
      this.checkoutModel.Model_StartDate = moment(val).format('yyyy-MM-DD');
      this.dialog = true;
    },
    checkUniformNo(uniformNo) {
      if (uniformNo && uniformNo.length === 8) {
        const overTen = function (value) {
          while (value >= 10) {
            value = Math.floor(value / 10) + (value % 10);
          }

          return value;
        };

        let intTmpSum = 0;

        for (let i = 0; i < 6; i++) {
          // 位置在奇數位置的*2，偶數位置*1，計算前6碼
          if (i % 2 === 1) {
            intTmpSum += overTen(parseInt(uniformNo[i]) * 2);
          } else {
            intTmpSum += parseInt(uniformNo[i]);
          }
        }
        const seventhNum = overTen(parseInt(uniformNo[6]) * 4);
        intTmpSum += parseInt(uniformNo[7]); // 第8碼*1

        if ((intTmpSum + seventhNum) % 10 === 0) {
          // 除以 10 後餘 0 表示正確，反之則錯誤
          return true;
        } else if (
          uniformNo[6] === '7' &&
          (intTmpSum % 10 === 0 || (intTmpSum + 1) % 10 === 0)
        ) {
          // 倘若第7碼為7，則第7碼以0或1來加總除10餘0也是正確的
          // *7是唯一一個乘以4後十位數跟個位數相加後不是個位數的(2+8=10)，所以可以是10或是1+0=1，而10可以被10整除，所以可以視為0(總值加10或0結果不變)
          return true;
        }
      }
      return false;
    },
    goCheckout() {
      if (!this.captchaVerify) {
        this.msg('請進行機器人驗證', 2000);
        return;
      }
      this.$refs.checkoutForm.validate();
      if (this.validCheckout) {
        this.checkoutModel.Model_SpaceID = this.spaceID;
        this.checkoutModel.Model_EndDate = moment(this.endDate).format(
          'YYYY-MM-DD'
        );
        this.checkoutModel.Model_OrderAmount = this.payment;
        this.dbio(
          '/ParkingOnlyReserved/CreateOrder',
          this.checkoutModel,
          'post'
        )
          .then(() => {
            this.showCarNo = this.checkoutModel.Model_CarShow;
            this.remindDialog = true;
            this.search();
            this.dialog = false;
          })
          .catch((error) => {
            if (error.message.includes('timeout')) {
              this.msg('預約失敗，請重新執行', 3000);
            }
          })
          .finally(() => {
            this.$refs.recaptcha.reset();
          });
      }
    },
    // 日期類型切換價格
    datePrice(type, date) {
      // TODO
      const dateList = this.spacePart.filter((x) =>
        moment(date).isSameOrAfter(x.ParkingReservedSpacePart_Date)
      );

      // 找到離目標最近的日期
      const theSapcePart = dateList.reduce((prev, current) => {
        const prevDiff = Math.abs(prev.ParkingReservedSpacePart_Date - date);
        const currentDiff = Math.abs(
          current.ParkingReservedSpacePart_Date - date
        );

        return currentDiff < prevDiff ? prev : current;
      }, dateList[0]);

      if (theSapcePart == null) return 0;

      switch (type) {
        case 1:
          return theSapcePart.ParkingReservedSpacePart_WorkDayAmount;
        case 2:
          return theSapcePart.ParkingReservedSpacePart_WeekendAmount;
        case 3:
          return theSapcePart.ParkingReservedSpacePart_HolidayAmount;
      }
    },
    captchaVerified(res) {
      this.checkoutModel.ReCAPTCHAToken = res;
      this.captchaVerify = true;
    },
    captchaExpired() {
      this.captchaVerify = false;
    }
  }
};
</script>
